<template>
    <div class="layout" v-if="$auth.ready()">
        <div v-if="$auth.check()">
            <div class="wrapper" v-if="$store.state.config.loaded">
                <div class="sidebar">
                    <sidebar />
                </div>
                <div class="page">
                    <config-bar />
                    <transition name="fade">
                        <router-view></router-view>
                    </transition>
                    <foo />
                </div>
            </div>
            <loader v-else />
        </div>
        <login v-else />
    </div>
    <loader v-else />
</template>

<script>
import Sidebar from '@/components/elements/Sidebar'
import ConfigBar from '@/components/elements/ConfigBar'
import Footer from '@/components/layout/footer'

export default {
    components: {
        Sidebar,
        ConfigBar,
        'foo': Footer
    },
    created () {
        this.$store.dispatch('getConfig')
    }
}
</script>

<style lang="scss">
@import "../../styles/vars.scss";

    .break {
        margin: $margin--main 0;
        height: 1px;
        background: rgba($color--dark, 0.15);
    }

    span.small {
        font-size: $fontsize--main;
    }

    .lines {

        .line {
            display: flex;
            justify-content: space-between;
            margin-bottom: $margin--small;

            .left, .right {
                white-space: nowrap;
            }

            &.small {
                font-size: $fontsize--sm;
            }

            &__total {
                margin-top: $margin--small;
                margin-bottom: 0;
                font-weight: $fontweight--bold;
            }
        }

        .break {
            height: 1px;
            background: rgba($color--dark, 1);
        }
    }

    .vgt-table thead tr th {
        white-space: nowrap;
    }

    th.vgt-left-align,
    th.vgt-right-align {
        text-align: left !important;
    }
    
    span.soon {
        font-size: $fontsize--large;
    }

    .vgt-global-search {
        // background: lighten($color--dark, 10%) !important;
        // border: none !important;
        // color: red !important;
    }

    .vgt-global-search input {

        &::placeholder {
            opacity: 0.75;
        }
    }

    .vgt-global-search__input .input__icon .magnifying-glass {
        border-color: $color--dark !important;
    }

    .vgt-global-search__input .input__icon .magnifying-glass:before {
        background: $color--dark !important;
    }

    .vgt-input:focus, .vgt-select:focus {
        border-color: $color--dark !important;
        color: $color--dark;
    }

    .table-column {

        &__description {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            max-width: 200px;

            &--long {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                max-width: 500px;
            }
        }

        &__external-id {
            text-align: left;
        }

        &__customer {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            max-width: 200px;
        }

        &__type {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            max-width: 200px;
        }
    }

    table.vgt-table td {
        color: $color--dark !important;
    }
    
    .layout {
        font-family: $fontfamily--secondary;
        color: $color--dark;
        font-size: $fontsize--main;

        .wrapper {
            display: flex;
            min-height: 100vh;
        }

        .row:not(.nomargin) > div {
            margin-bottom: $margin--main;
        }

        .row:not(.nomargin) {
            margin-bottom: -$margin--main;
        }

        .sidebar {
            flex: 0 0 250px;
        }

        .color {

            &__main {
                color: $color--main;
            }

            &__good {
                color: $color--good;
            }

            &__avg {
                color: $color--avg;
            }

            &__bad {
                color: $color--bad;
            }
        }

        .page {
            padding-top: 80px;
            flex: 1;
            overflow-y: auto;
            height: 100vh;
            background: $bg--light;
            position: relative;
            width: calc(100vw - 250px);
        }

        h1, h2, h3, h4, h5, h6, .title, .headline {
            font-family: $fontfamily--main;
            font-weight: $fontweight--bold;
        }

        .section {
            padding: $padding--large;
        }

        .placeholder {
            background: $color--white;
            box-shadow: $boxshadow--creative;
            border-radius: $borderradius--main;
            overflow: hidden;
            height: 100%;

            &.fit-content {
                height: fit-content;
            }

            .placeholder {
                overflow: unset;
            }

            &.padding {
                padding: $padding--main;
            }

            &.align-self-center {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
            }

            &__heading {
                font-size: $fontsize--sm;
                padding: $padding--small;
                font-weight: $fontweight--bold;
                color: $color--white;
                background: $color--dark;
                text-align: center;
            }

            &__total {
                text-align: center;
                padding: $padding--small;
                font-weight: $fontweight--bold;

                input {
                    border: 1px solid $color--light;
                    border-radius: $borderradius--main;
                    width: 40px;
                    font-size: $fontsize--main;
                    text-align: center;
                }

                button {
                    background: $bg--light;
                    padding: 0 ($padding--small / 2);
                    border-radius: $borderradius--main;
                    
                    &:first-of-type {
                        background: $color--dark;
                        color: #fff;
                    }
                }
            }

            &__number-title {
                font-weight: $fontweight--main;
                margin-bottom: $margin--small / 2;
            }

            &__number-value {
                font-size: $fontsize--xl;
                font-weight: $fontweight--bold;
                font-family: $fontfamily--main;
            }
        }

        .helper {
            position: absolute;
            top: calc(80px + #{$padding--large});
            right: $padding--large;
            background: $color--dark;
            padding: $padding--small;
            color: $color--white;
            width: 50px;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: $boxshadow--main;
            border-radius: $borderradius--main;
            opacity: .5;
            cursor: pointer;
            transition: $transition--main;

            &:hover {
                opacity: 1;
            }
        }
    }

    .box-date-range {
        display: flex;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 15px;
        font-size: $fontsize--small;
        animation: fadeIn 0.3s ease-in-out forwards;
        // z-index: 99;

        .text {
            font-weight: $fontweight--bold;
        }

        > div:not(:first-of-type) {
            margin-left: 5px;
        }

        .vdp-datepicker__calendar {
            top: -285px;
        }
    }

    .vdp-datepicker input {
        outline: none !important;
    }

    .vdp-datepicker__calendar .cell.selected {
        background: $color--dark !important;
        color: #fff !important;
    }

    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid $color--dark !important;
    }

    .v-data-footer {
        height: 50px;
    }

    .v-data-footer__select {
        display: none !important;
    }

    .v-data-table th {
        text-align: left;
    }

    .v-data-table__wrapper table tbody tr td.text-start:first-of-type {
        font-weight: bold;
    }

    .v-data-table__wrapper table tbody tr td {
        overflow: hidden;
    }

    @media (min-width: 1264px) {
        .container {
            max-width: 1600px !important;
        }
    }

    .divider {
        height: 1px;
        background: rgba(0, 0, 0, 0.15);
        margin: $margin--main 0;
    }

    .color {

        &-good {
            color: $color--good;
        }

        &-avg {
            color: $color--avg;
        }

        &-bad {
            color: $color--bad;
        }
    }

    .day__month_btn.up,
    .month__year_btn.up {
        position: relative;
        line-height: 24px;
        height: 40px;
        font-weight: bold;
    }

    .day__month_btn.up::before,
    .month__year_btn.up::before {
        content: "Tryk for at vælge måned";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 99999999999999;
        color: $color--dark;
        font-size: $fontsize--small;
        white-space: nowrap;
        font-weight: normal;
        opacity: 0.75;
    }

    .month__year_btn.up::before {
        content: "Tryk for at vælge årstal";
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance:textfield;
    }

    .pretty-button {
        background: $color--green;
        display: inline-block;
        padding: $padding--small;
        border-radius: $borderradius--main;
        box-shadow: $boxshadow--creative;
        color: $color--white;
        cursor: pointer;
        transition: $transition--main;

        &.fw {
            width: 100%;
            text-align: center;
        }

        &:hover {
            background: darken($color--green, 5%);
        }

        &.inverse {
            background: transparent;
            margin: 0 $margin--small;
            color: $color--dark;
            box-shadow: none;

            &:hover {
                background: $color--dark;
                color: $color--white;
            }
        }
    }

    .warning {
        background: $color--bad;
        padding: $padding--small;
        margin-bottom: $margin--main;
        font-size: $fontsize--sm;
        line-height: 1.5;
        border-radius: $borderradius--main;

        b {
            display: block;
        }
    }

</style>

<style lang="scss">
@import "../../styles/vars.scss";

    /* .apexcharts-legend-series {
        margin-top: $margin--small !important;
    } */

    .helper-content {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 99999;
        display: flex;
        justify-content: center;
        align-items: center;

        .inner {
            max-width: 80%;
            max-height: 80%;
            overflow-y: auto;
            width: 800px;
            background: #fff;
            padding: 30px;
            border-radius: 10px;
            box-shadow: $boxshadow--creative;

            .title {

                &__big {
                    font-size: $fontsize--large;
                    font-weight: $fontweight--bold;
                    margin-bottom: $margin--small;
                }

                &__medium {
                    font-size: $fontsize--main;
                    font-weight: $fontweight--bold;
                    margin-bottom: $margin--small;
                    border-bottom: 1px solid $color--dark;
                    padding-bottom: 5px;
                }
            }

            ol, ul {
                padding-left: 40px;
            }

            table {
                width: 100%;
                text-align: center;
                table-layout: fixed;

                td {
                    padding: $padding--small / 4;
                }
            }
        }
    }

    .swal2-container,
    .swal2-container * {
        font-family: $fontfamily--main;
    }

    .swal2-container a,
    .swal2-icon.swal2-info {
        color: $color--dark !important;
        border-color: $color--dark !important;
    }

    .swal2-confirm {
        background: $color--dark !important;
    }

    .table-title {
        font-size: $fontsize--sm;
        padding: $padding--small;
        font-weight: $fontweight--bold;
        color: $color--white;
        background: $color--dark;
        text-align: center;
        border-radius: $borderradius--main $borderradius--main 0 0;
    }

    .vgt-responsive {
        // width: calc(100% + 1px) !important;
    }
    
    table.vgt-table {
        font-size: 14px !important;
    }

    table.vgt-table tr.selected {
        background: $color--dark;

        * {
            color: $color--white;
        }
    }

    table.vgt-table tr.clickable:hover {
        background: rgba(0, 0, 0, 0.15) !important;
    }

    table.vgt-table tr.clickable.selected:hover {
        background: $color--dark !important;
    }

    .vgt-table thead th.sorting-desc:after {
        border-top-color: $color--dark !important;
    }

    .vgt-table th.sorting:after {
        border-bottom-color: $color--dark !important;
    }

    .vgt-wrap__footer {
        border-radius: 0 0 $borderradius--main $borderradius--main;
    }

    .vgt-wrap__footer .footer__navigation__page-btn .chevron.left::after {
        border-right-color: $color--dark !important;
    }

    .vgt-wrap__footer .footer__navigation__page-btn .chevron.right::after {
        border-left-color: $color--dark !important;
    }

    table.vgt-table td {
        vertical-align: middle !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .coverage-cell {
        display: flex;
        align-items: center;
        // justify-content: flex-end;
        justify-content: flex-end;
        flex-direction: row-reverse;
    }

    .vgt-right-align {
        text-align: left !important;
    }

    .coverage-indicator {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        display: inline-block;
        margin-right: 5px;
        background: none;

        &.bad {
            background: $color--bad;
        }
        
        &.avg {
            background: $color--avg;
        }

        &.good {
            background: $color--good;
        }

        &.status {
            background: $color--grey;
        }
    }

    .g-table {

        &__action {
            
            i {
                padding: 4px;
                cursor: pointer;
            }

            &:hover {

                i {
                    --fa-secondary-color: $color--dark;
                    --fa-secondary-opacity: 1;
                }
            }
        }
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
        max-width: 400px;
    }
    
    .tooltip .tooltip-inner {
        background: $color--white;
        color: $color--dark;
        border-radius: 16px;
        // padding: 5px 10px 4px;
        padding: $padding--main;
        font-family: $fontfamily--secondary;
        font-weight: 400;
        box-shadow: $boxshadow--creative;
        font-size: $fontsize--sm;
        line-height: 1.5;
    }
    
    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: $color--white;
    }
    
    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }
    
    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }
    
    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }
    
    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }
    
    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }
    
    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }
    
    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }
    
    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }
    
    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }
    
    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }

    .g-table-wrapper {
        background: $color--white;
        border-radius: 0 0 $borderradius--main $borderradius--main;
        box-shadow: $boxshadow--creative;
    }

    table.vgt-table td {
        overflow: unset !important;
    }

    .dropdown-toggle {
        background: $color--dark !important;
        color: $color--white !important;
        font-weight: $fontweight--bold !important;
        border-radius: $borderradius--main !important;
        overflow: hidden !important;
        font-size: $fontsize--small !important;

        .caret {
            top: 17px !important;
        }
    }

    .employee-switcher {
        display: inline-flex;
        border-radius: 3px;
        overflow: hidden;
        box-shadow: $boxshadow--main;
        font-size: 14px;
        margin-bottom: 10px;

        &-option {
            padding: 10px 15px;
            background: #fff;
            cursor: pointer;
            transition: $transition--main;

            &:hover {
                box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
            }

            &.selected {
                background: $color--dark;
                color: #fff;
            }

            &:not(:last-of-type) {
                border-right: 1px solid rgba(0,0,0,0.1);
            }
        }
    }

</style>



// WEBPACK FOOTER //
// layout.vue?007452b6